import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.field-crop-advisor', () => {
  import('./internal/field-crop-advisor').then(({ default: Component }) => Component());
});
